<script>
  export let size = 20;
</script>

<svg width={size} height={size} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
  <g>
    <path d="M7.8125 5L12.8125 10L7.8125 15" stroke="currentColor" stroke-width="1.5" />
  </g>
</svg>
